import { useBreakpoints } from 'src/styles';

export const useCompactLayout = () => {
  return useBreakpoints({ smallerThanOrEqualTo: 'tablet' });
};
